import { getAnalytics } from 'common/analytics';
export const AV_ADDRESS = 'AV Address';
export const AV_ADDRESS_RETRY = 'AV Retry Address';
export const AV_ID_UPLOAD = 'AV ID Upload';
export const AV_REVIEW = 'AV Review';
export const AV_FAIL = 'AV Fail';

const getStepName = step => {
  return step === 'address_retry' ? AV_ADDRESS_RETRY : AV_ADDRESS;
};

export function trackAddressUpdateFailure(step, data) {
  const eventName = `${getStepName(step)} Form Submission Failed`;
  getAnalytics().track(eventName, data);
}

export function trackAddressUpdateSuccess(step) {
  const eventName = `${getStepName(step)} Form Submission Successful`;
  getAnalytics().track(eventName);
}

export function trackIdSubmitSuccess() {
  const eventName = 'AV ID Submitted Successfully';
  getAnalytics().track(eventName);
}

export function trackLogOutButton(page) {
  getAnalytics().track(`${page} Page Sign Out Button Clicked`);
}

export function trackLogOutLink() {
  getAnalytics().track('AV Form Logout Link Clicked');
}

export function trackIdUploadModalAbandoned() {
  getAnalytics().track(`${AV_ID_UPLOAD} Modal Abandonded`);
}

export function trackIdUploadModalOpened() {
  getAnalytics().track(`${AV_ID_UPLOAD} Modal Opened`);
}

export function trackStepEntered(step) {
  getAnalytics().track('Entered AV Step', {
    step,
  });
}

export function trackReviewAbandoned() {
  getAnalytics().track('AV Exited Pending Page');
}

export function trackReviewLostFocus() {
  getAnalytics().track('AV Departed Pending Page');
}

export function trackReviewVideoPlayback(timeInSeconds) {
  getAnalytics().track('AV Pending Page Video played', {
    timeElapsed: timeInSeconds,
  });
}
